import { Link } from "react-router-dom";



const akatistText = `


 ( Чита се за помоћ ОМЛАДИНИ која је у стању очаја, и ПОРОДИЦАМА које је обузела дрога, алкохол, криминал и сви остали проблеми)

Кондак 1.

Нека се радују и веселе верујући благодарећи Богу за проналазак светих моштију Великомученика Јефрема, кроз кога тече река чуда и небројена исцељења тако да му сви певамо у један глас: Радуј се Свети великомучениче Јефреме, нови чудотворче!

Икос 1.

Видела је игуманија Макарија небеску поворку у којој су свете мошти твоје побожно носили људи којима си на разне начине помогао. Ко може набројати све болеснике који су се избавили патњи, твојим молитвама?
Или набројати децу која су здравила од болести које су их мучиле? Или побројати све људе који су победили искушења теби се обраћајући? Зато ти певамо:

Радуј се, јер си много пострадавши за Христа примио неувенљиви венац,
Радуј се, јер је пројава твојих моштију орадоснила Хришћане,
Радуј се, јер из твојих икона теку сузе и миро,
Радуј се, јер нам тако јављаш да се ниси удаљио од нас,
Радуј се, јер су многе цркве теби посвећене,
Радуј се, надо свих узнемирених које безнађе и неверје мучи,
Радуј се, јер си се јавио девојци која је целивала мошти Светог Јована Руског,
Радуј се, јер јe она схватила да светитељи ЗДРУЖЕНО ПОМАЖУ,
Радуј се, као онај који има лек за сваку болест,
Радуј се, јер се вест о твојој моћи по свим земљама прочула,
Радуј се, Свети великомучениче Јефреме, нови чудотворче!

Кондак 2.

„Изађи напоље, Лазаре, пријатељу љубљени, у сну је чула болесница твој глас,
као онда Лазар из Јеванђеља глас Господњи,
А пошто је оздравила, видевши на икони лик твој, препознала је те с радошћу. И посведочивши твоју помоћ, људима је рекла да кличу Богу: Алилуја!

Икос 2.

Показао си се мајци болесног детета
рекавши: „Ја сам Јефрем, Све време 
мислим на тебе.” 

О, кад би се и ми удостојили таквог небесног дара! Знајући за твоју велику љубав за све верујуће људе, усуђујемо се да те молимо да бринеш за наше душе, певајући ти:
Радуј се, јер си следивши Св. Јефрема Сиријског постао духовна харфа
Радуј се, достојни учениче Спаситеља Христа Победитеља смрти
Радуј се, проповедниче вере у Васкрсење,
Радуј се, јер твој спомен празнујемо с великим поштовањем,
Ралуј се, дару Божији верујућем народу,
Радуј се, јер си изобличио веру  се, јер си се трпљењем показао јачим од твојих прогонитеља,
Радуј ce, jep свете мошти твоje сведоче твоју стветост,
Радуј се, јер твој кивот проповеда живот вечни,
Радуј се, јер нас упућујеш да духовно васкрсавамо,
Радуј се, оштра сабљо која сасецаш трње грехова који нас притискају,
Радуј се, огњу који сажижеш плеву са њива душа наших,
Радуј се, Свети всликомучениче Јефреме нови чудотворче!

Кондак 3.

Сазнали смо како си на чудесан начин
обавестио младу девојку да треба да дође да се поклони твојим моштима и да је благословиш. Знамо и да си
jе исцелио од њене болести, након што ти се она усрдно помолила. И ми чезнемо за твојом небеском помоћи, мили Светитељу, желећи да и ми
живимо под твојим благословом и да певамо Богу: Алилуја!

Икос 3.

Јавио си се у сну жени која ти се молила
да је избавиш од тешке болести рака рекавши јој: „Од сада ђути бити заштитник”, а она се у вери утврдила. Буди од сада и наш заштитник, Свети и помози нама и свима хришћанима,
свим јерарсима и свештеницима, свим монасима и мирјанима, свим родитељима и деци да познају дар који
ти јe од Бога дат и да те хвале овако:
Радуј се, ти који си заволео Христа и од
Њега примио дар жртвене љубави,
Радуј се, ти кога ходочасници који походе твој манастир тајно призивају,
Радуј се, јер си се много пута показивао
онима којима је помоћ била потребна,
Радуј се, јер нас учиш да не тражимо
љубав људску, већ Божију,
Радуј се, јер је твоја душа испуњена
Божијом љубављу према нама,
Радуј се, јер од тебе учимо како да се
одричемо наше зле воље,
Радуј се, ти који отклањаш поделе међу
верујућима.
Радуј се, ти који нас учиш да ценимо љубав ка ближењем више него правду,
Радуј се, ти који благосиљаш оне који дају побожне завете,
Радуј се, утехо слабих и беспомоћних
Радуј се, оградо која штитиш оне којима
желе зло,
Радуј се, јер призивањем твог имена ђаволске појаве нестају,
Радуј се Свети великомучениче Јефреме, нови чудотворче !

Кондак 4.

Жену која те је молила да добије онај крст који може понети, обрадовао си рођењем другог детета, иако је њена утроба била неплодна 8 година. А она је, саветујући супружнике да рађају децу и да их у славу Богу васпитавају, не страхујући од тешкоћа, хвалила Бога: Алилуја!

Икос 4.

Млада Софија ce молила Богу ceдам година да дарива дете свом супругу и душа њена ce већ обесхрабрила,
када си joj након што ти ce помолила, помогао. A када ce то детенце по рођењу разболело и лекари рекли да ће умрети, мама је са надом одговорила
да се њему ништа неће десити, јер си јој га ти обећао. И ниси постидео њену веру већ си лекаре постидео кад је 

новорођенче оздравило, а мама ти овако певала:
Радуј се, лекару од Бога послати, што боравиш уз болесничко узглавље,
Радуј се, јер си жени која ти се молила
за крст који може понети, рађање другог детета устројио.
Радуј се, јер помажеш брачницима да
одагнају страх од рађања деце,
Радуј се, јер их учиш да своју вољу одбаце и траже Божију вољу,
Радуј се, јер си дете којем су ногице
помазане уљем из твог манастира, од напрасне смрти сачувао,
Радуј се, јер си дете за које су лекари 
рекли да ће ослепети и умом оболети Учинио здравим.
Радуј се, јер лечиш не само тела него и болесне умове,
Радуј се, јер и младе лекаре чиниш способнијим од искусних,
Радуј се, ти који примаш молитве и болесника и лекара,
Радуј се, ти који посећујеш оне који су исцрпљени болестима,
Радуј се, јер твојом снагом побеђујеш нашу природу,
Радуј се, небески леку који сваку нашу бол и болест удаљаваш од нас,
Радуј се Свети великомучениче Јефреме, нови чудотворче!

Кондак 5.

Много су се ожалостили родитељи малог Јефтимија када их детенце више није препознавало, ударало их и гризло и бивало болесније, 
а лекари признали да немају сазнања како да му помогну. Али пошто су се рођаци молили теби, три пута си се појавио у болничкој соби 
и од тада је болест почела да јењава, док дете није сасвим оздравило, а сви су Богу певали песму: „Алилуја!”

Икос 5.

Када су неверујући лекари рекли да јe
беба у утроби супруге свештеника Михаила тешко болесна и искушавали родитеље да прихвате грех чедоморства, свештеник је
рекао: „Бог ће нас наградити ако дозволи да носимо тако тежак крст као што су нам лекари предсказали.” Али због њихових молитава помогао си им и здраво новорођенче се родило, које је на крштењу твоје име добило а свештеник и његова супруга су ти овако
узносили похвале:

Радуј се, рајски цвету који умирисујеш хришћанске домове,
Радуј се, јер је свештеник Михаил познао снагу твоје молитве,
Радуј се, јер је његова супруга проповедала твоја чуда,
Радуј се, ти који се молиш да се оснажимо у вери,
Радуј се, јер нас упућујеш да Бога слушамо више него лекаре,
Радуј се, јер су твојим молитвама оздравила деца на самрти,
Радуј се, јер од напрасне смрти штитиш
оне за које ти се молимо,
Радуј се, прибежиште душа поклеклих од патње,
Радуј се, ти који отиреш сузе безнадежних родитеља,
Радуј се, ти који одгониш демоне од
ђавоимане деце,
Радуј се, јер од тебе олакшање траже они које муче нечисти духови,
Радуј се, врели молитвениче за 

хришћански род,
Радуј се Свети великомучениче Јефреме, нови чудотворче!

Кондак 6.

Када Cy деца чула своју Majкy како обећава да ће родити још једно дете, ако оздрави и да ћe му дати твоје име, шесторо деце су у један глас повикали: „Не мама, немој више рађати, брини
caмо о нама !?" Али жена добивши помоћ од тебе коју је тражила, није послушала себичне дечије речи, већ је
слушајући глас савести одржала обеђање, славећи Бога и узвикујући: „Алилуја!”

Икос 6.
Десеторо деце је у својој утроби већ била изгубила Евангелија, једно чедо јој 

је
умрло одмах по рођењу, а само једно дете је остало y животу, када je жена поново зачела, а лекари тражили да одустане од детета. 
Али она je сву наду положила y Бога и твоје молитве, трпећи нападе мужа који јој je греx
чедоморства предлагао. Њено трпљење је крунисано и доневши на свет девојчицу твоје чудо хвалимо овако:
Радуј се, јер је жена победила искушења
и родила новорођенче,
Радуј се, ти који помажеш мајкама у
трудноћи и на порођају,
Радуј се, ти који чуваш верујуће мајке од
греха чедоморства,
Радуј се, јер их ти штитиш и оне
слушају Бога, а не неверујуће лекаре окамењених срца,
Радуј се, јер дајеш снагу мајкама да се
успротиве неверујућим мужевима,
Радуј се, ти који си многе утробе ослободио неплодности,
Радуј се, ти који си исцелио болесна тела нероткиња,
Радуј се, ти који покајање устројаваш
женама које не желе децу,
Радуј се, ти који посматраш мноштво деце која су на свет дошла чувана тобом,
Радуј се, јер су лекари занемели када си
немогуће учинио могућим,
Радуј се, ти који си чуо молитве деце
која нису желела да остану јединци у родитеља,
Радуј се, ти који штитиш децу која носе твоје име,
Радуј се Свети великомучениче Јефреме, нови чудотворче!

Кондак 7.


Много се молила Атена за своју умирућу
мајку, када те је видела, а ти си јој тада обећао да ће оздравити. Лекари су узвикнули: „Ово је право васкрсење из мртвиху", видевши нова и здрава плућа у умирућој жени, због чега су сви певали Богу: Алилуја!

Икос 7.

Појавио си се у сну девојчици Екатерини, ставши поред ње док се њен отац теби молио чинећи метаније. А она је разумела како су корисне молитве родитеља за децу и колико
их штите. Зато те ми молимо да заштитиш сву вepyjyћy децу и хвалимо тe овако:
Радуј се, јер си прибежиште оној деци чији ти се родитељи моле,

Радуј се, јер си налик Светом Стелијану у бризи о деци,
Радуј се, гласу који упућујеш младе да иду путем Цркве,
Радуј се, ти који си се показао младом
човеку који је желео да дигне руку на себе,
Радуј се, јер си му помогао да схвати
колики је терет његових грехова,
Радуј се, ти који си га одвео кући и из
греховног пијанства отрезнио,
Радуј се, јер се твојом помоћу ослободио ланаца пијанства и наркоманије,
Радуј се, анђеле чувару који мир узне миреним душама дарујеш,
Радуј се, јер си спасао живот жени, која je желела да га оконча, показавши јој се,
Радуј се, јер помажеш младима да нађу
смисао живота.
Радуј се, јер одгониш лењост која убија

душу,
Радуј се, ти који због молитава верујуће
деце и саме родитеље штитиш,
Радуј се Свети великомучениче Јефреме, нови чудотворче!

Кондак 8.

"Најдрагоценија помоћ детету је Свето
Причешће”, поручио си жени чије је дете
дошло на свет твојим молитвама. Пробуди, Свети, ревност у свим верујућим родитељима да би васпитавали децу у Цркви и примали
Свете Тајне не на суд или осуду, већ за живот, вечни и да би сви заједно клицали Богу: Алилуја!”

Икос 8.

Новопридошла девојчица у сиротиште 
које се налазило у твом манастиру, се ишчуђавала како су се остала деца припремала за исповест записујући своје грехе, да их не би заборавили
на исповести, али се њено чуђење стишало, пошто си јој се јавио у сну и затражио да се и она исповеди, због чега ти ми певамо овако:
Радуј се, јер је слушајући твој савет девојчица почела да се исповеда,
Радуј се, јер је била сведок твојих чуда,
Радуј се, јер си многе упутио на исповест,
Радуј се, јер и од деце примаш хвалу као жртвени принос срца,
Радуј се, жигу светости којим су срца оних који ти се моле запечаћена,
Радуј се, јер поучаваш децу да се припреме за Свето Причешће,
Радуј се, ти који учиш молитви оне који те поштују,
Радуј се, јер твојим молитвама деца постају мали алостоли православне вере,
Радуј се, молитвениче за непослушну младеж и и слабоверујуће.
Радуј се, јер младима дариваш мудрост старих,
Радуј ce, jep учиш родитеље да одгајају децу у Цркви.
Pajyj ce, бесцено благо сакривено y срцима нашим,
Радуј се Свети великомучениче Јефреме, нови чудотворче!

Кондак 9.

Девојци која ти се молила за помоћ
да оснује породицу си се јавио у сну и рекао: "Помоћи ћу ти да будеш yз оног когa желиш."
И твоја реч се обистинила, јер је девојку

запросио младић кога је волела. Помози Свети свим младима који желе да оснују породицу да направе добар избор да Бог благослови брак, да би у све дане певали Богу: „Алилуја!”

Икос 9.

Марија, одабачена од мужа и родитеља
много је туговала што њен син расте без оца. Али пошто ти се усрдно помолила, наредног дана је њен муж схватио своју грешку и молио је да се врати кући. Видевши твоју брзу помоћ, молимо ти се да одагнаш поделе
и немире у свим хришћанским породицама, упуђујући сваког да ти заједно са нама пева овако:
Радуј се, јер си близу оних које притиска усамљеност,
Радуј се, јер доносиш мир домовима у које је ђаво унео раздор,
Радуј се, јер враћаш породицама оне које су страсти заробиле,
Радуј се, јер умекшаваш окамењена срца и узнемиреност претвараш у спокој,
Радуј се, проналашче изгубљених ствари,
Радуј се, ти који си пред судијама оправдао неправедно осуђене,
Радуј се, ти који све неправедно осрамоћене оправдаваш,
Радуј се, ти које си оне који нису имали како да зараде корисно упутио,
Радуј се, ти који одмараш исцрпљене прекомерним пословима,
Радуј се, ти који нас учиш исправном расуђивању,
Радуј се, ти који си се међу гостима појавио y дому верујућиг хришћанина,
Радуј се, предворје онима који су удаљени од светлости Светог Крштења,
Радуј се Свети великомучениче Јефреме, нови чудотворче!

Кондак 10.

Много се трудио да прослави Бога учени
и богољубиви Фотије, у чијој кући је Свети прва твоја икона насликана. И примивши венац славе, јер је умножио дароване му таланте, на свршетку његовог живота си му душу узнео на небо. А његова побожна супруга
то видевши је Богу певала: „Алилуја!”

Икос 10.

Слушај дете моје, узећу са собом твоју
маму, али се ти не плаши. То је воља Божија и погледај како дивно место сам јој спремио”, 
рекао си Анули показавши јој лепоте Раја.
„Немој постати плен туте, јер ћy ja увек
бити поред тебе и штитићу те", чула је твоје обећање и душа јој се умирила. 
А ми ти се молимо да будеш близу све деце сирочића и овако ти певамо:
Радуј се, јер никог у невољи без помоћи не остављаш,
Радуј се, јер сирочиће штитиш,
Радуј се, јер им помажеш да одаберу добро, клонећи се грехова,
Радуј се, јер им доносиш потребито,
Радуј се, јер распоређујеш све што је корисно,
Радуј се, чувару чистоте младих људи,
Радуј се, оче, иконо врлина осликана у нашим душама,
Радуј се, јер прекореваш неуздржљивост а похваљујеш уздржање,
Радуј се, јер одгониш самртни страх од оних који ти се моле,
Радуј се, јер припремаш хришћане да се сретну са Праведним Судијом,
Радуј се, ти који стижеш у предсмртни час крај оних који cy те молили да им будеш заштитник,
Радуј се, јер твоје речи и чуда чувамо у срцима нашим,
Радуј се Свети великомучениче Јефреме, нови чудотворче!

Кондак 11.

„Нисам могао да се сусртенем са њеном
прљавом душом”, рекао си о жени која је тражила твоју помоћ, а није желела да се одрекне безакоња и ђавола коме је служила.
Изагнавши ђавола, удаљио си жену од
себе, јер није желела да покајањем душу
очисти и да пева Богу: „Алилуја!”


Икос 11.

Једна жена коју си ти исцелио, сањала је да прилази твојим светим моштима да их целива, али да je ђаво у томе спречава говорећи да је грешна. 
„Баш зато што сам грешна ићи ћу да целивам Св Јефрема, таман умрла на месту!” рекла је жена желевши у
свом животу твоју заштиту. Њена ревност нам је пример, нама, који ти се молимо овако:
Радуј се, јер твојим молитвама у нама узраста жеља за светошћу,
Радуј се, јер покајаним грешницима устројаваш што им је корисно,
Радуј се, ти који оштро грдиш непокајане грешнике,
Радуј се, покровитељу оних који желе твојим моштима да се поклоне,

Радуј се, благопријатна жртво на небесном олтару принесена,
Радуј се, ти који одгониш злурада сплеткарења,
Радуј се, ти који посрамљујеш учењаке жедне славе,
Радуј ce, ти који нe примаш похвале од лицемера,
Радуј се, ти који се супротстављаш ђаволу који нас спречава да чинимо дела вере,
Радуј се, јер сабљом молитве одгониш ђаволе од оних који ти се моле,
Радуј се, љути непријатељу који прогониш гордост, лаж и лакомост,
Радуј се, примеру трпљења, вере и подвига,
Радуј се Свети великомучениче Јефреме, нови чудотворче!

Кондак 12.


"Вреди да и ми мало пропатимо ради
љубави Христове", рекао си монахињи која се борила са искушењем и показао си јој твоје мученичке ране. И нама треба твоје охрабрење Свети, јер су се таласи овог живота подигли на нас и притиска нас безнађе,
Помози нам да превазиђемо тешкоће коjе нас притискају да би смо Богу певали: Алилуја !

Икос 12.

" Чим си ме позвала дошао сам!” рекао си жени која се молила да исцелиш сина и испунио си јој мољење. И ми те призивамо Свети, помози нам, не остави нас, јер нам је много потребна твоја помоћ, слуго Божији и
зато те овако хвалимо:

Радуј се, чувару предања светих отаца,
Радуј се, јер нас твоја дела уче више него речи,
Радуј се, јер је архијереј који је сумњао У
твоју светост разумео своју грешку,
Радуј се, стено о коју се спотичу недостојни клирици,
Радуј се, jер их поучаваш да напусте грехе и да иду путем светости,
Радуј се, јер нам у бедама брзо долазиш у помоћ,
Радуј се, јер оне који носе крст невоља
штитиш од видљивих непријатеља,
Радуј се, јер је онај који је украо делић
твојих моштију, вратио их у манастир,
Радуј се, ти који кориш хришћане који воле грех,
Радуј се, сапутниче побожних ходочасника,
Радуј се, јер си нас, претрпевши мучења
прогонитеља, научио да се не бојимо патње,
Радуј се, јер награђујет оне који се труде да стигну код твојих моштију,
Радуј се Свети великомучениче Јефреме, нови чудотворче !

Кондак 13.

О многострадални и великомучениче Jeфреме, који си се чудесно ликом показао и посведочио своју љубав
за нас, незахвалне и незадовољне, који се молимо да чинимо вољу Божију, али живимо по сопственој огреховљеној вољи, подај своју помоћ и сада свима који ти се моле и свима за које
ти се молимо, да би тако постављајући добар почетак спасењу захвално певали Богу, прослављеном у Тројици: „Алилуја!”

(Овај конgак се чита 3 пута, па Икос 1.
Конgак  1. )


Трпат глас 1.

На планини Амомон, приказао си се као
сунце, о ти послушниче Божији, за Богом
у мучеништво си отишао; нападе варвара претрпео си, Јефреме, о ти Христов великомучениче, због чега ти је дана милост, да помажеш онима који побожно узвикну твоје име, Слава Њему који снагу ти даде, Слава Њему који чудотворним те учини, Слава
Њему који милост ти даде да преко тебе лечиш све!

 


`

function Akatist1() {
    return <div style={{whiteSpace: 'pre-wrap', textAlign: 'left', margin: 20}}>

<Link to="/"> Nazad </Link>
        <div style={{display: "flex", justifyContent: 'center'}}>



        <img src="jefrem.jpg" alt="sv jefrem" />
        </div>
        <br></br>
        <h3 style={{textAlign: 'center'}}>
            АКАТИСТ СВЕТОМ ЈЕФРЕМУ ЧУДОТВОРЦУ НЕАМАКРИЈСКОМ
        </h3>
        {akatistText}
    </div>
}

export default Akatist1;